import {
	ACTIVITY_MARK,
	ACTIVITY_RESET,
	AUTH_LOGIN_SUCCESS,
	AUTH_LOGOUT,
} from '../constants/actionTypes';
import { MS_UNTIL_IDLE } from '../constants';
import Cookie from 'js-cookie';
import { markActivity, resetActivity } from '../actions/activity';
import { logout } from '../actions/auth';

const makeId = () =>
	Math.random()
		.toString(36)
		.substring(4);

const checkInactivity = store => next => action => {
	const { type } = action;

	const actionTypesToIgnore = [
		ACTIVITY_MARK,
		ACTIVITY_RESET,
		AUTH_LOGOUT,
		AUTH_LOGIN_SUCCESS,
	];

	if (actionTypesToIgnore.indexOf(type) === -1) {
		const { activity, auth } = store.getState();

		if (!auth.isAuthenticated) {
			return next(action);
		}

		const activityTime = new Date(activity.time || new Date());
		const currentTime = new Date();
		const diff = currentTime - activityTime;

		if (diff === 0) {
			store.dispatch(markActivity(action.type));
			return next(action);
		}

		if (diff < 5000) return next(action);

		if (diff > MS_UNTIL_IDLE) {
			const { form } = store.getState();
			const key = makeId();

			Cookie.set(key, form, { expires: 1 });

			const currentPath = window.location.pathname;

			const url = `/login?url=${currentPath}&formKey=${key}`;

			store.dispatch(resetActivity());
			store.dispatch(logout('You have been logged out because of inactivity.'));
			return (window.location.href = url);
		}

		store.dispatch(markActivity(action.type));
	}

	return next(action);
};

export default checkInactivity;



// WEBPACK FOOTER //
// ./src/middlewares/inactivityMiddleware.js